import Vue from 'vue'
// import LastBids from 'FrontComponents/vue/LastBids/Index.vue'
// import PriceHighLight from 'FrontComponents/vue/PriceHighLight/Index.vue'
import { store } from '../../components/front/vue/store/store'

if (document.querySelector('#auction-widgets')) {
    const LastBids = () => import(/* webpackChunkName: "assets/widget" */ 'FrontComponents/vue/LastBids/Index.vue')
    const PriceHighLight = () => import(/* webpackChunkName: "assets/widget" */ 'FrontComponents/vue/PriceHighLight/Index.vue')

    let mixin = {
        methods: {
            route: route,
        },
    }

    new Vue({
        el: '#auction-widgets',
        mixins: [mixin],
        store,
        components: {
            LastBids,
            PriceHighLight,
        },
    })
}

$('aside .tab-outter').click(function() {
    if ($(window).width() <= 991) {
        $('aside').addClass('opened')
    }
})
$(window).resize(function() {
    if ($(window).width() > 991) {
        $('aside').removeClass('opened')
    }
})
$('aside .aside-mobile-close').click(function() {
    $('aside').removeClass('opened')
})
